// PaymentMethodsScreen.tsx
import React from "react";
import { useTheme } from "../../common/hooks/useTheme";
import { MobileHeader } from "../../common/components/mobileHeader/MobileHeader";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import styles from "./PaymentMethodsScreen.module.scss";
import { PaymentMethodsContent } from "./сomponents/paymentMethodsContent/PaymentMethodsContent";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";

export default function PaymentMethodsScreen() {
  const { theme } = useTheme();

  return (
    <div className={styles.container} style={{ backgroundColor: theme.background }}>
      <PageMeta />
      
      <div className={styles.mobileOnly}>
        <MobileHeader title="Способы оплаты" />
      </div>

      <div className={styles.desktopOnly}>
        <ProductHeader
          title="Способы оплаты"
          isFavorite={false}
          showFavorite={false}
          textColor={theme.text}
          borderColor={theme.border}
        />
      </div>

      <div className={styles.scrollView}>
        <div className={styles.content}>
          <PaymentMethodsContent mode="screen" />
        </div>
      </div>
    </div>
  );
}